import { Dispatch } from "redux";
import { setLoading } from "./global";
import VoucherService from "service/RaffleAncolMonth";
import { showMessage } from "utilities/helper";
import {
  VoucherPayloadTypes,
} from "utilities/types/Voucher";
import { CatalogDescriptionPayloadTypes } from "utilities/types/CatalogDescription";

export const getAllReward =
  (
    page: number = 1,
    search: string = "",
    limit: number = 10,
    filterTenant: number = 3
  ) =>
  async (dispatch: Dispatch) => {
    dispatch(setLoading(true));
    dispatch({
      type: "SET_VOUCHER_CURRENT_PAGE",
      currentPage: page,
    });
    dispatch({
      type: "SET_SEARCH_VOUCHER",
      searchValue: search,
    });

    try {
      const data = await VoucherService.getAllReward(
        page,
        search,
        limit,
        filterTenant
      );

      dispatch(setLoading(false));
      dispatch({
        type: "SET_VOUCHER",
        value: data.catalogs,
      });
      dispatch({
        type: "SET_VOUCHER_PAGE",
        totalPage: !!data.catalogs.length ? data.last_page : 1,
        limitPage: limit,
        lengthPage: !!data.catalogs.length ? data.total_data : 1,
      });
      dispatch({
        type: "SET_VOUCHER_FILTER_PAGE",
        filterTenantPage: filterTenant,
      });
    } catch (err: any) {
      dispatch(setLoading(false));
      if (err.request.status !== 401) {
        console.log("error :", err);
        showMessage(
          !err.response
            ? err.message
            : !!err.response?.data?.error
            ? err.response?.data?.error
            : err.response?.data?.message,
          "error"
        );
      }
    }
  };

export const storeReward =
  (form: VoucherPayloadTypes, handleCloseModal: () => void) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    const payload = form;
    try {
      const data = await VoucherService.storeReward(payload);
      const { currentPage, searchValue, limitPage, filterTenantPage } =
        getState().voucherReducer;

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });

      dispatch(
        getAllReward(
          currentPage,
          searchValue,
          limitPage,
          filterTenantPage
        ) as any
      );

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const updateReward =
  (
    voucherId: string,
    form: VoucherPayloadTypes,
    handleCloseModal: () => void
  ) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    const payload = form;
    try {
      const data = await VoucherService.updateReward(voucherId, payload);
      const { currentPage, searchValue, limitPage, filterTenantPage } =
        getState().voucherReducer;

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });

      dispatch(
        getAllReward(
          currentPage,
          searchValue,
          limitPage,
          filterTenantPage
        ) as any
      );

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const deleteReward =
  (voucherId: string, handleCloseModal: () => void) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    try {
      const data = await VoucherService.deleteReward(voucherId);
      const { currentPage, searchValue, limitPage, filterTenantPage } =
        getState().voucherReducer;

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });

      dispatch(
        getAllReward(
          currentPage,
          searchValue,
          limitPage,
          filterTenantPage
        ) as any
      );

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const updateRewardDescription =
  (form: CatalogDescriptionPayloadTypes, handleCloseModal: () => void) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    const payload = form;
    try {
      const data = await VoucherService.updateRewardDescription(payload);
      const { currentPage, searchValue, limitPage, filterTenantPage } =
        getState().catalogReducer;

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_DESCRIPTION", value: false });

      dispatch(
        getAllReward(
          currentPage,
          searchValue,
          limitPage,
          filterTenantPage
        ) as any
      );

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };